import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=5a391087&scoped=true"
import script from "./todo.vue?vue&type=script&lang=js"
export * from "./todo.vue?vue&type=script&lang=js"
import style0 from "./todo.vue?vue&type=style&index=0&id=5a391087&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a391087",
  null
  
)

export default component.exports